var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotsBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2560,
    height: 388,
    viewBox: "0 0 2560 388",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 34,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 66,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 98,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 130,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 162,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 194,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 226,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 258,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 290,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 322,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 354,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 386,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 2,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 66,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 98,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 130,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 162,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 194,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 226,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 258,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 290,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 322,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 354,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 386,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 2,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 34,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 98,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 130,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 162,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 194,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 226,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 258,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 290,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 322,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 354,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 386,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 2,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 34,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 66,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 98,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 130,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 162,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 194,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 226,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 258,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 290,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 322,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 354,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 386,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 2,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 34,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 66,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 98,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 130,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 162,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 194,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 226,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 258,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 290,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 322,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 354,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 386,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 2,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 34,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 66,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 98,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 130,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 162,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 194,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 226,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 258,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 290,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 322,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 354,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 386,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 2,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 34,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 66,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 98,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 130,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 162,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 194,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 226,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 258,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 290,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 322,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 354,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 386,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 2,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 34,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 66,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 98,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 130,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 162,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 194,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 226,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 258,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 290,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 322,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 354,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 386,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 2,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 34,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 66,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 98,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 130,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 162,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 194,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 226,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 258,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 290,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 322,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 354,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 386,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 2,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 34,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 66,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 98,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 130,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 162,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 194,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 226,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 258,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 290,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 322,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 354,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 386,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 2,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 34,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 66,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 98,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 130,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 162,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 194,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 226,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 258,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 290,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 322,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 354,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 386,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 2,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 34,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 66,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 98,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 130,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 162,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 194,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 226,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 258,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 290,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 322,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 354,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 386,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 2,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 34,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 66,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 98,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 130,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 162,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 194,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 226,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 258,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 290,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 322,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 354,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 386,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 2,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 34,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 66,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 98,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 130,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 162,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 194,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 226,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 258,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 290,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 322,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 354,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 386,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 2,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 34,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 66,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 98,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 130,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 162,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 194,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 226,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 258,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 290,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 322,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 354,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 386,
    r: 2,
    fill: "#7CCBC7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsBackground);
export default __webpack_public_path__ + "static/media/dots_background.330f69f9bcf8c517d1bdea0e84cc27f3.svg";
export { ForwardRef as ReactComponent };